import {ContentModal} from 'sma.common/components/modals';

let ajax = require('sma.common/ajax');
let block = require('sma.common/block');
const guidestarOverwriteModalTemplate = require('sma.applicant/organizations/partials/guidestar_overwrite_modal.mustache');
const guidestarOrgUpdateModalTemplate = require('sma.applicant/organizations/partials/guidestar_org_update_modal.mustache');


class GuideStarView extends Backbone.View {
	get events() {
		return {
			'click #guidestar .sma-js-button-ok': 'useGuideStar',
			'click #guidestar .sma-js-button-cancel': 'clearEIN',
			'click #sma-js-use-guidestar-org-modal': 'openUpdateModal',
			'change #id_country': 'updateEnableDisable',
		}
	}

	constructor(config) {
		super();
		this.setElement($(config.element));
		this.$inputEl = this.$el.find('input[name="ein"]');
		this.$countryEl = this.$el.find('#id_country');
		this.$guideStarEl = this.$el.find('#guidestar');
		this.$guideStarDisabledMessageEl = this.$el.find('#guidestar_disabled');
		this.$guideStarOrgUpdateButtonEl = this.$el.find('#sma-js-use-guidestar-org-modal');
		this.updateEnableDisable();
	}

	clearEIN() {
		this.$inputEl.val('');
	}

	fetchGuideStarFields(ein, callback) {
		ajax.post({
			data: { ein: ein },
			url: reverse('guidestar-organization'),
			contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
			alertOnSuccess: false,
			callback: callback
		});
	}

	useGuideStar() {
		let ein = this.$inputEl.val();
		this.fetchGuideStarFields(ein, (response) => {
			if (this.willDataBeOverwritten(response.guidestar_mapped_values)) {
				this.overwriteConfirmationModal(response.guidestar_mapped_values);
			} else {
				this.importGuideStarValues(response.guidestar_mapped_values, true);
			}
		});
	}

	openUpdateModal() {
		let defaultEin = $('#id_tax_number').val();
		let content = guidestarOrgUpdateModalTemplate({
			body_line: gettext("To update your organization's profile, provide your EIN"),
			overwrite_message: gettext('Overwrite fields that already have data'),
			ein_placeholder: gettext('Enter the tax number'),
			default_ein: defaultEin
		});
		let that = this;

		this.dialog = new ContentModal(
			content, {
				destroyOnClose: true,
				title: gettext('Update'),
				buttons: [
					{
						label: gettext('Cancel'),
						cls: 'btn btn-link',
						handler: (modal) => {
							modal.hide();
						},
					},
					{
						label: gettext('Ok'),
						cls: 'btn btn-primary',
						handler: (modal) => {
							let ein = modal.$el.find('[name="ein"]').val();
							let shouldOverwrite = modal.$el.find('[name="overwrite"]').is(':checked');

							that.fetchGuideStarFields(ein, (response) => {
								this.importGuideStarValues(response.guidestar_mapped_values, shouldOverwrite);
							});
							modal.hide();
						},
					},
				],
			},
		);
		this.dialog.show();
	}

	updateEnableDisable() {
		let country = this.$countryEl.val();

		if (country == 'US' || country == '') {
			block.unblock(this.$guideStarEl);
			block.unblock(this.$guideStarOrgUpdateButtonEl);
			this.$guideStarDisabledMessageEl.hide();
		} else {
			block.block(this.$guideStarEl);
			block.block(this.$guideStarOrgUpdateButtonEl);
			this.$guideStarDisabledMessageEl.show();
		}
	}

	willDataBeOverwritten(guidestarMappedValues) {
		for (let variable_id in guidestarMappedValues) {
			if (variable_id == 'country') {
				// Ignore this since country will probably have a value (US)
				// since that's needed for the user to use GuideStar
				continue;
			}
			let $variable = $('#id_' + variable_id);
			if ($variable.val()) {
				return true;
			}
		}
		return false;
	}

	importGuideStarValues(guidestarMappedValues, shouldOverwrite) {
		for (let [variable_id, value] of Object.entries(guidestarMappedValues)) {
			let $variable = $('#id_' + variable_id);
			if ($variable.val() && !shouldOverwrite) {
				continue;
			}

			if (variable_id == 'tax_number') {
				if ($('#id_tax_country option[value="0"]').length) {
					$('#id_tax_country').val('0');
					$variable.val(value);
				}
			} else if (variable_id == 'country') {
				$variable.val('US');
			} else {
				$variable.val(value);
			}
		}
	}

	overwriteConfirmationModal(guidestarMappedValues) {
		let content = guidestarOverwriteModalTemplate({
			body_line_1: gettext('Using Guidestar will affect data that you have already entered.'),
			body_line_2: gettext('What would you like to do with the data already entered?'),
			overwrite_message: gettext('Overwrite fields that already have data'),
			keep_data_message: gettext('Keep information that I have entered'),
		});
		let that = this;

		this.dialog = new ContentModal(
			content, {
				destroyOnClose: true,
				title: gettext('Use GuideStar'),
				buttons: [
					{
						label: gettext('Cancel'),
						cls: 'btn btn-link',
						handler: (modal) => {
							modal.hide();
						},
					},
					{
						label: gettext('Ok'),
						cls: 'btn btn-primary',
						handler: (modal) => {
							let overwriteValue = modal.$el.find('[name="overwrite"]:checked').val();
							let shouldOverwrite = overwriteValue == 'overwrite';
							that.importGuideStarValues(guidestarMappedValues, shouldOverwrite);
							modal.hide();
						},
					},
				],
			},
		);
		this.dialog.show();
	}
}

module.exports = {
	GuideStarView
}




// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/organizations/guidestar.js